import type { FormFieldType } from "@tellescope/types-models";
import type { FormTypesWithValues } from "../types";

export const convertFormFieldType = (type: FormFieldType): FormTypesWithValues | null => {
  switch (type) {
    case "Table Input":
      return "Input Table";
    case "Question Group":
    case "description":
    case "Emotii":
    case "Chargebee":
      return null;
    default:
      return type;
  }
};
